import script from "./ConsultBoardListPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConsultBoardListPage.vue?vue&type=script&setup=true&lang=ts"

import "./board/BoardPage.scss?vue&type=style&index=0&lang=scss&external"
import "./mall/MallMyListPage.scss?vue&type=style&index=1&lang=scss&external"
import "./ConsultBoardListPage.scss?vue&type=style&index=2&lang=scss&external"

const __exports__ = script;

export default __exports__